import { Map /* fromJS */ } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_ADYEN_STATE_PROVINCE_SHOWN:
      return state.set('stateProvinceShown', action.payload)
    case actions.SET_ADYEN_DROP_IN_READY:
      return state.set('ready', action.payload)
    case actions.SET_ADYEN_DROP_IN_ERROR:
      return state.set('error', action.payload)
    case actions.SET_ADYEN_PROCESSING:
      return state.set('processing', action.payload)
    case actions.INCREMENT_ADYEN_DROP_IN_REMOUNT_NONCE:
      return state.set(
        'dropInRemountNonce',
        state.get('dropInRemountNonce', 0) + 1,
      )
    case actions.RESET_ADYEN:
      return initialState.set(
        'dropInRemountNonce',
        state.get('dropInRemountNonce', 0),
      )
    default:
      return state
  }
}
